import styled from 'styled-components';

import { colorsV2 } from '../../colors-v2';

export const Dash = styled.div`
  min-width: 88px;
  height: 24px;
  align-self: start;
  margin-right: 8px;
  line-height: 20px;
  border-bottom: 2px solid ${colorsV2.gray50};
`;
